var _defs, _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSym(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1542 1378",
    width: 1542,
    height: 1378,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Symbotic Investor Presentation 2022-1-pdf-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-17439.71-3166.79h25367.53v14250.54h-25367.53z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #4f5354 } \n\t\t.s1 { fill: #78be20 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: Page 1",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 5",
    className: "s0",
    d: "m1049.5 72.6l379.2 238.8c72.7 46.2 112.3 108.2 112.3 170.2 0 62-37 120.1-105.7 165l-664.6-418.3-401.6 253.3 664.6 418.3-263 166.3-656.6-414.4c-72.7-46.2-112.3-106.8-112.3-170.2 0-64.6 39.6-125.3 112.3-170.2l376.5-238.8c75.4-46.2 174.4-72.6 280.1-72.6 104.4 0 203.5 26.4 278.8 72.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 6",
    className: "s1",
    d: "m770.7 1149.3l401.7-253.4-664.6-418.2 262.9-166.3 656.7 415.6c72.7 44.9 113.6 105.6 113.6 168.9 0 64.7-40.9 125.4-113.6 171.6l-376.6 237.5c-73.9 46.2-173 72.6-278.7 72.6-105.7 0-204.8-26.4-278.8-72.6l-379.2-238.8c-72.7-46.2-113.6-108.2-113.6-170.3 0-62 38.3-120 105.7-164.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSym);
export default __webpack_public_path__ + "static/media/SYM.bd93fac95d5bb5691b2fa1364f591dae.svg";
export { ForwardRef as ReactComponent };